import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Box, Button, Container, Paper, Stack, Typography } from '@mui/material';
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <HelmetProvider>
      <Helmet>
        <title>404 - Página Não Encontrada | Gateway Contagem</title>
      </Helmet>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: '#f8fafc',
          px: 2,
          py: 6,
        }}
      >
        <Container maxWidth="sm">
          <Paper
            elevation={0}
            sx={{
              p: { xs: 4, sm: 6 },
              borderRadius: '16px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)',
              textAlign: 'center',
              bgcolor: '#ffffff',
            }}
          >
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: '50%',
                bgcolor: '#f0f9ff',
                color: '#0284c7',
                border: '1px solid #e0f2fe',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 3,
              }}
            >
              <FindInPageOutlinedIcon sx={{ fontSize: 36 }} />
            </Box>

            <Box
              sx={{
                display: 'inline-block',
                px: 1.5,
                py: 0.5,
                borderRadius: '999px',
                bgcolor: '#f0f9ff',
                color: '#0369a1',
                fontSize: '0.75rem',
                fontWeight: 700,
                letterSpacing: '0.05em',
                textTransform: 'uppercase',
                mb: 2,
              }}
            >
              Erro 404
            </Box>

            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: '#0f172a',
                mb: 1.5,
                fontSize: { xs: '1.5rem', sm: '1.75rem' },
              }}
            >
              Página Não Encontrada
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: '#64748b',
                mb: 4,
                lineHeight: 1.6,
                maxWidth: 420,
                mx: 'auto',
              }}
            >
              A página que procura não existe, foi movida ou o endereço introduzido está incorreto.
            </Typography>

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              justifyContent="center"
            >
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate(-1)}
                sx={{
                  borderRadius: '10px',
                  px: 3,
                  py: 1,
                  textTransform: 'none',
                  fontWeight: 600,
                  borderColor: '#cbd5e1',
                  color: '#334155',
                  '&:hover': {
                    borderColor: '#94a3b8',
                    bgcolor: '#f8fafc',
                  },
                }}
              >
                Página Anterior
              </Button>
              <Button
                component={RouterLink}
                to="/Gateway/Dashboard"
                variant="contained"
                startIcon={<HomeIcon />}
                sx={{
                  borderRadius: '10px',
                  px: 3,
                  py: 1,
                  textTransform: 'none',
                  fontWeight: 600,
                  bgcolor: '#1B75BB',
                  boxShadow: 'none',
                  '&:hover': {
                    bgcolor: '#155d96',
                    boxShadow: 'none',
                  },
                }}
              >
                Voltar ao Início
              </Button>
            </Stack>
          </Paper>
        </Container>
      </Box>
    </HelmetProvider>
  );
};

export default NotFound;
